__turbopack_context__.v({
  "header": "NewsBase-module-scss-module__f0W5wG__header",
  "section": "NewsBase-module-scss-module__f0W5wG__section",
  "sub": "NewsBase-module-scss-module__f0W5wG__sub",
  "title": "NewsBase-module-scss-module__f0W5wG__title",
});
